const BASE_URL = window.location.origin;

export const fomrTemplateUrl = `${BASE_URL}/api/intakeForm/template`;
export const fomrInstanceLocalUrl = `${BASE_URL}/api/intakeform/instance`;
export const fomrInstanceUrl = `${BASE_URL}/api/form/global`;
export const formPutUrl = `${BASE_URL}/api/form/value`;
export const formSubmitUrl = `${BASE_URL}/api/form/submit`;
export const formUrl = `${BASE_URL}/api/form`;
export const enumUrl = `${BASE_URL}/api/enumeration`;
